module.exports = __webpack_public_path__ + "img/logo.ef4feba7.png";